export const MAX_RECORDING_LENGTH_MS = 60000
export const IMAGE_MAX_DIMENSION_ONE_SECTION = 768
export const IMAGE_MAX_DIMENSION_OVER_ONE_SECTION = 512
export const MIN_IMAGE_SCALE = 0.5
export const MAX_IMAGE_SCALE = 3
export const SETTINGS_ACCEPTED_TERMS_AND_CONDITIONS_VERSION =
  'accepted_terms_and_conditions_version'
